import React from 'react';
import DownloadReportPortfolio from './DownloadReportPortfolio';

const DownloadHourlyPortfolio = () => (
  <DownloadReportPortfolio reportType="hourly" />
);

export default DownloadHourlyPortfolio;
